import {LOADING,
  LOADED,
} from '../actions/types';

const INITIAL_STATE = {
  isLoading: false,
};

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOADING:
      return { ...state,
        isLoading: true,
      };
    case LOADED:
        return { ...state,
            isLoading: false,
          };
    default:
      return { ...state
      }
  }

}